module.exports = __webpack_public_path__ + "static/img/05.3b1ba78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/05.png
// module id = kyll
// module chunks = 2